import { render } from "./Incapacidades.vue?vue&type=template&id=4dded655&scoped=true"
import script from "./Incapacidades.vue?vue&type=script&lang=js"
export * from "./Incapacidades.vue?vue&type=script&lang=js"

import "./Incapacidades.vue?vue&type=style&index=0&id=4dded655&scoped=true&lang=css"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/gasoil/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dded655"]])

export default __exports__